import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconColumns3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconColumns3"><Path d="M8 21H5.75C4.23122 21 3 19.7688 3 18.25V5.75C3 4.23122 4.23122 3 5.75 3H8V21Z" fill="currentColor"/><Path d="M14.5 3V21H9.5V3H14.5Z" fill="currentColor"/><Path d="M18.25 3C19.7688 3 21 4.23122 21 5.75V18.25C21 19.7688 19.7688 21 18.25 21H16V3H18.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconColumns3;
